import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { GetAccountTokenResponseBody } from "../types/account.type";

export const createAccountQueries = (api: CoreApiClient) => {
  const { client } = api;

  const tokenStatus = async (token: string): Promise<GetAccountTokenResponseBody> => {
    const { data, error, response } = await client.GET("/account-token/{token}", {
      params: { path: { token } },
    });
    if (error) throw new Error(`Get account token status failed [status:${response.status}]`);
    return data;
  };

  return {
    tokenStatus,
    queries: createQueryKeys("account", {
      tokenStatus: (token: string) => ({
        queryKey: [token],
        queryFn: () => tokenStatus(token),
      }),
    }),
  };
};
